import fromPairs from 'lodash/fromPairs'
import toPairs from 'lodash/toPairs'

export function promiseObj<O>(obj: {
  [Property in keyof O]: Promise<O[Property]>
}): Promise<{[Property in keyof O]: O[Property]}> {
  //@ts-ignore: toPairs -> fromPairs won't typecheck
  return Promise.all(toPairs(obj).map(([k, p]) => p.then(v => [k, v]))).then(fromPairs)
}
